import React, {Component} from "react";

import {View, Text, TextInput, TouchableOpacity, Image}  from 'react-native';

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'

import * as util from '../util/util'

import * as numeros from '../util/numeros'

import * as data from '../util/data'

import Botao from '../componentes/Botao'

import {MaskedTextInput} from "react-native-mask-text";

import RotuloErro from '../componentes/RotuloErro'

import {USER_TIPO_PF, USER_TIPO_PJ} from '../util/constantes'

import cores from '../util/cores'

import ver_senha from '../imgs/ver_senha.png'

import ocultar_senha from '../imgs/ocultar_senha.png'

import Combo from '../componentes/Combo'



export default class FormularioUsuario extends Component {
																								
	
	constructor(props) {
        
        super(props);
		
		this.state = {
			tipo: USER_TIPO_PF,
			cpf: null,
			cnpj: null,
			nascimento: null,
			nome: null,
			email: null,
			tel: null,
			senha: null,
			repeteSenha: null,
			msgErro: null,
			mostrarSenha: true
        };
	
		this.btSalvarRef = React.createRef();

		this.cbTipoRef = React.createRef();
    }
	

	setDados(tipo, cpf, cnpj, nascimento, nome, email, tel, senha){

        this.setState({tipo: tipo});
		this.setState({cpf: cpf});
		this.setState({cnpj: cnpj});
		this.setState({nascimento: nascimento});
		this.setState({nome: nome});
		this.setState({email: email});
		this.setState({tel: tel});
		this.setState({senha: senha});
		this.setState({repeteSenha: null});	

		if(this.cbTipoRef.current)
			this.cbTipoRef.current.setIdSelecionado(tipo);	
    }
	

	mudouTipo(novoTipo){
		
		this.setState({tipo: novoTipo.id});
		
		if(novoTipo == USER_TIPO_PF)
			this.setState({cnpj: null});
		else{
			
			this.setState({cpf: null});
		
			this.setState({nascimento: null});
		}
	}


	validar(){
		
		this.btSalvarRef.current.setCarregando(true)
        
		this.setState({msgErro: null});
	
		const { salvar } = this.props;
		
		let cpf_cnpj_formatado = null;

		if(!this.props.novo){

			cpf_cnpj_formatado = (this.state.tipo == USER_TIPO_PF? numeros.formatarSomenteNum(this.state.cpf):
									numeros.formatarSomenteNum(this.state.cnpj));
		
			if(texto.isBlanck(cpf_cnpj_formatado)){

				this.salvarErro("Informe seu CPF ou CNPJ.");
				return;
			} 
		}

		if(texto.isBlanck(this.state.nome)){

            this.salvarErro("Informe seu nome ou razão social.");
            return;
        } 

		if(texto.isBlanck(this.state.email)){

            this.salvarErro("Informe seu endereço de E-mail.");
            return;
        }

		let tel_formatado = null;
		let nascimento_formatado = null;

		if(!this.props.novo){

			tel_formatado = numeros.formatarSomenteNum(this.state.tel);

			if(texto.isBlanck(tel_formatado)){

				this.salvarErro("Informe seu telefone de contato.");
				return;
			}

			nascimento_formatado = data.converteDataBrParaEua(this.state.nascimento);

			if(this.state.tipo == USER_TIPO_PF && texto.isBlanck(nascimento_formatado)){
				
				this.salvarErro("Informe sua data de nascimento.");
				return;
			}
		}

		if(this.props.novo || this.props.editarSenha){
			
			if(texto.isBlanck(this.state.senha) || this.state.senha.length<8){

				this.salvarErro("Informe uma senha de pelos menos 8 caracteres.");
				return;
			}
		}
		
		salvar({"nome_completo": this.state.nome, 
					"tipo": this.state.tipo, 
						"cpf_cnpj": cpf_cnpj_formatado, 
							"email": this.state.email, 
									"tel": tel_formatado,
										"nascimento": nascimento_formatado,
											"senha": this.props.editarSenha || this.props.novo?this.state.senha:null});
	}
	
	
	salvarErro(mensagem){
		
        this.btSalvarRef.current.setCarregando(false);
		this.setState({msgErro: mensagem});
    }


	salvarSucesso(){
		
		this.btSalvarRef.current.setCarregando(false)
		this.setState({msgErro: null});
	}
	
	
	
     render() {
		
		let dados = [{'id': USER_TIPO_PF, 'nome': "Pessoa Física"}, 
			{'id': USER_TIPO_PJ, 'nome': "Pessoa Jurídica"}];
		
		return(
			<View>  
				<View style={{marginTop:10}}/>   

				{!this.props.novo && 
					<View> 
						
						<View style={{marginTop:20}}/> 
						
						<Combo 
							mostrarVazio = {false}
							rotulo="Tipo:"
							dados={dados} 
							aoMudar={(valor)=>this.mudouTipo(valor)}
							selecionado={this.state.tipo}
							ref={this.cbTipoRef}/>
						
						<View style={{marginTop:30}}/> 
					
						{(this.state.tipo === USER_TIPO_PF)?(
							<View> 
								<Text style={estilos.rotulo_padrao}>CPF:</Text>
										
								<MaskedTextInput  
										placeholder="" 
										mask="999.999.999-99"
										style={estilos.campo_padrao} 
										onChangeText={(text, rawText)=>this.setState({cpf: (rawText === ''?null:rawText)})}
										keyboardType="numeric"
										value={this.state.cpf}/>
							</View>):(
							<View>
								<Text style={estilos.rotulo_padrao}>CNPJ:</Text>
										
								<MaskedTextInput  
										placeholder="" 
										mask="99.999.999/9999-99"
										style={estilos.campo_padrao} 
										onChangeText={(text, rawText)=>this.setState({cnpj: (rawText === ''?null:rawText)})}
										keyboardType="numeric"
										value={this.state.cnpj}/>
							</View>)
						}
					</View>
				}	

				<View style={{marginTop:30}}/> 
								
				<Text style={estilos.rotulo_padrao}>{(this.state.tipo === USER_TIPO_PF)?('Nome'):('Razão Social')}:</Text>
							
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.setState({nome: text})}
					maxLength={150}
					value={this.state.nome}/>
		
				<View style={{marginTop:30}}/> 
																	
				<Text style={estilos.rotulo_padrao}>E-mail:</Text>
							
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>this.setState({email: text})}
					maxLength={150}
					value={this.state.email}/>
				
				<View style={{marginTop:30}}/>
				
				{!this.props.novo && 
					<View> 
						<View style={estilos.grade}>
							<View style={estilos.coluna_dupla}> 
						
								<Text style={estilos.rotulo_padrao}>Telefone:</Text>
											
								<MaskedTextInput  
									placeholder="" 
									mask="(99) 99999-9999"
									style={estilos.campo_padrao} 
									onChangeText={(text, rawText)=>this.setState({tel: (rawText === ''?null:rawText)})}
									keyboardType="numeric"
									value={this.state.tel}/>
									
							</View>
							<View style={estilos.coluna}/> 
						</View>	

						<View style={{marginTop:30}}/>

						<View style={estilos.grade}>
							<View style={estilos.coluna_dupla}> 
							
								{ this.state.tipo == USER_TIPO_PF &&
									<View>
										<Text style={estilos.rotulo_padrao}>Nascimento:</Text>
													
										<MaskedTextInput  
											placeholder="" 
											mask="99/99/9999"
											style={estilos.campo_padrao} 
											onChangeText={(text, rawText)=>this.setState({nascimento: (rawText === ''?null:rawText)})}
											keyboardType="numeric"
											value={this.state.nascimento}/>
									</View>				
								}
							</View>
							<View style={estilos.coluna}/> 
						</View>		
					</View>
				}

				{this.props.editarSenha || this.props.novo && 
					<View>
						<Text style={estilos.rotulo_padrao}>Senha:</Text>
												
						<View style={estilos.grade}>
                            <View style={estilos.coluna}>                  
                                <TextInput
                                    placeholder="Digite sua senha..."
                                    style={estilos.campo_padrao} 
                                    secureTextEntry={this.state.mostrarSenha}
                                    textContentType={'password'} 
                                    multiline={false}
                                    onChangeText={(text)=>this.setState({senha: text})}
                                    maxLength={32}
                                    value={this.state.senha}/>
                            </View>
                            <TouchableOpacity onPress={()=>this.setState({mostrarSenha: !this.state.mostrarSenha})}>
								<View style={{borderColor: cores.cinza_claro,borderWidth:1, marginLeft:2, borderRadius:4, padding:3}}>
									{this.state.mostrarSenha?
										<Image source={ver_senha} style={{width:30, height: 30}}/>:
										<Image source={ocultar_senha} style={{width:30, height: 30}}/>
									}
								</View>
                            </TouchableOpacity>
                        </View>   
					</View>
				}
							
				<View style={{marginTop:30}}/>
				
				{util.temConteudo(this.state.msgErro) &&
					<View style={{alignItems:'center'}}>
						<RotuloErro mensagem={this.state.msgErro}/>
					</View>
				}
				
				<View style={{marginTop:30}}/>
				
				<View style={estilos.grade}>
					<View style={estilos.coluna}/> 
					<View style={[estilos.coluna_dupla, {alignItems:'center'}]}>
						<Botao 
							acao={()=>this.validar()}
							texto="Salvar Usuário"
							ref={this.btSalvarRef}/>    
					</View>
					<View style={estilos.coluna}/> 
				</View> 
				
				<View style={{marginTop:30}}/>
			</View> 
		)
	}
} 